

export const wan = {
    tabs: { textToVideo: '文字转视频', imageToVideo: '图片转视频' },
    upload: { addImage: '添加图片', formats: 'JPG、PNG、WebP • 最大 10MB' },
    prompt: {
      label: '提示词',
      placeholder: '描述你要生成的视频…',
      sub: '描述期望的运动与内容',
      count: '{count} / 800'
    },
    groups: {
      duration: '时长',
      resolution: '分辨率',
      aspect: '画面比例',
      aspectInfo: '输出视频比例将与上传图片一致'
    },
    advanced: {
      title: '高级设置',
      negativePrompt: '反向提示',
      negativePlaceholder: '描述你不希望在视频中出现的内容…',
      negativeHelp: '可选：描述需要避免的内容',
      seed: '种子',
      seedPlaceholder: '随机（留空）',
      seedHelp: '可选：指定种子以便重现结果'
    },
    credits: { bar: '积分消耗', value: '{value} 积分' },
    actions: { generate: '生成视频（{value} 积分）' },
    preview: { title: '准备就绪', desc: '配置设置后点击生成，开始创作精彩视频' }
  };
